import { ChangeEvent, FC, useCallback } from "react";
import { IconButton, Stack, TextField } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  deleteSharedCost,
  updateSharedCost,
} from "@/store/dimensions/dimensionsSlice";
import { useAppAbility } from "@/services/permissions";
import { useAppDispatch } from "@/store/hooks";

interface DimensionCostAllocationCardCollapseHeaderProps {
  collapsed: boolean;
  toggleCollapsed(): void;
  sharedCostId: string;
  sharedCostName: string;
}

export const DimensionCostAllocationCardCollapseHeader: FC<
  DimensionCostAllocationCardCollapseHeaderProps
> = ({ toggleCollapsed, collapsed, sharedCostId, sharedCostName }) => {
  const dispatch = useAppDispatch();
  const { cannot } = useAppAbility();
  const canNotDeleteCategory = cannot("delete", "category");

  const deleteHandler = useCallback(
    () => dispatch(deleteSharedCost(sharedCostId)),
    [sharedCostId, dispatch],
  );

  const nameChangeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        updateSharedCost({ id: sharedCostId, name: event.target.value }),
      );
    },
    [sharedCostId, dispatch],
  );

  return (
    <Stack p={1.5} direction="row" spacing={1} alignItems="center">
      <IconButton size="small" onClick={toggleCollapsed}>
        {collapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </IconButton>

      <TextField
        autoFocus
        fullWidth
        size="small"
        value={sharedCostName}
        type="text"
        sx={{ mt: 0.5 }}
        label="Rule Name"
        onChange={nameChangeHandler}
      />

      <IconButton
        onClick={deleteHandler}
        disabled={canNotDeleteCategory}
        size="small"
      >
        <DeleteOutlineIcon />
      </IconButton>
    </Stack>
  );
};
